import axios from "axios";
import { Method_POST, URL } from "../../../../../../../service/api";
import { toast } from "react-toastify";

const BASE_URL = URL;


export const fetchListDocumento = async (numeroSolicitacao) => {
  try {
    const url = `/ordem-servico/documento/listar`;
    const data = { id: numeroSolicitacao };
    const responseData = await Method_POST(url, data);

    return responseData?.files || []; 
  } catch (error) {
    console.error("Erro ao buscar documentos:", error.message);
    return [];
  }
};

export const uploadDocumentoProps = (numeroSolicitacao, endpoint, objDocs, setObjDocs) => {
  const customRequest = async ({ file, onSuccess, onError, nomeParaSalvar }) => {
    
    const finalFileName = nomeParaSalvar;

    // O nomeParaSalvar é garantido pelo Componente Filho através do find(status === "Pendente")
    if (!finalFileName) {
      toast.error("Erro: Etapa de importação não identificada.");
      return;
    }

    const originalExtension = file.name.split('.').pop();
    const renamedFile = new File([file], `${finalFileName}.${originalExtension}`, {
      type: file.type,
    });

    const formData = new FormData();
    formData.append("file", renamedFile);
    formData.append("path", `ordem-${numeroSolicitacao}`);
    formData.append("filePrefix", "");
    formData.append("fileCategory", "DOCUMENTO_EMPRESA");

    try {
      const response = await axios.post(`${BASE_URL}${endpoint}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.status === 200 || response.status === 204) {
        toast.success(`${finalFileName} carregado com sucesso!`);
        onSuccess("ok");
        const updatedDocs = await fetchListDocumento(numeroSolicitacao);
        setObjDocs(updatedDocs);
      }
    } catch (error) {
      toast.error(`Falha ao enviar arquivo para: ${finalFileName}`);
      onError(error);
    }
  };

  return { name: "file", multiple: false, customRequest };
};